export function crearOfertaDescuentoFirma() {
  return {
    id: 0,
    ofertaId: 0,
    campaniaId: 0,
    plazoDescuentoCampaniaId: 0,
    dias: 0,
    descuento: 0,
  };
}
